import { useNavigate } from "react-router-dom";

export default function About() {
  const navigate = useNavigate();

  return (
    <>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600&family=JetBrains+Mono:wght@400;500&display=swap');

        .ab-root {
          font-family: 'Inter', -apple-system, sans-serif;
          background: #faf9f8;
          color: #1a1a1a;
          min-height: calc(100vh - 60px);
          padding: 40px 24px 80px;
          max-width: 680px;
          margin: 0 auto;
        }

        .ab-back {
          display: inline-flex;
          align-items: center;
          gap: 6px;
          font-size: 13px;
          color: #5a5a5a;
          cursor: pointer;
          background: none;
          border: none;
          padding: 0;
          margin-bottom: 32px;
          font-family: inherit;
          transition: color 0.15s;
        }
        .ab-back:hover { color: #1a1a1a; }

        .ab-title {
          font-size: 24px;
          font-weight: 600;
          letter-spacing: -0.4px;
          margin-bottom: 6px;
          line-height: 1.2;
        }
        .ab-title em { font-style: normal; color: #c8571a; }

        .ab-sub {
          font-size: 13.5px;
          color: #9a9a9a;
          margin-bottom: 32px;
          line-height: 1.6;
        }

        .ab-card {
          background: #ffffff;
          border: 0.5px solid rgba(0,0,0,0.09);
          border-radius: 8px;
          padding: 22px 24px;
          margin-bottom: 12px;
        }

        .ab-card-head {
          display: flex;
          align-items: center;
          gap: 12px;
          margin-bottom: 14px;
        }

        .ab-card-icon {
          width: 34px;
          height: 34px;
          border-radius: 7px;
          display: flex;
          align-items: center;
          justify-content: center;
          flex-shrink: 0;
        }

        .ab-card-title {
          font-size: 14px;
          font-weight: 600;
          color: #1a1a1a;
          letter-spacing: -0.1px;
        }

        .ab-body {
          font-size: 13.5px;
          color: #5a5a5a;
          line-height: 1.85;
          margin: 0;
        }

        .ab-tools-grid {
          display: grid;
          grid-template-columns: 1fr 1fr;
          gap: 8px;
          margin-top: 16px;
        }

        .ab-tool-chip {
          background: #faf9f8;
          border: 0.5px solid rgba(0,0,0,0.08);
          border-radius: 6px;
          padding: 10px 14px;
        }
        .ab-tool-chip-name {
          font-size: 13px;
          font-weight: 600;
          margin-bottom: 2px;
        }
        .ab-tool-chip-tag {
          font-size: 11px;
          color: #9a9a9a;
          font-family: 'JetBrains Mono', monospace;
          letter-spacing: 0.04em;
        }

        .ab-model-row {
          display: flex;
          gap: 8px;
          margin-top: 16px;
          flex-wrap: wrap;
        }

        .ab-model-chip {
          display: flex;
          align-items: center;
          gap: 7px;
          padding: 7px 12px;
          background: #faf9f8;
          border: 0.5px solid rgba(0,0,0,0.09);
          border-radius: 6px;
          font-size: 12px;
          font-family: 'JetBrains Mono', monospace;
          color: #3a3a3a;
          letter-spacing: 0.02em;
        }

        .ab-model-dot {
          width: 7px;
          height: 7px;
          border-radius: 50%;
          background: #1a7a4a;
          flex-shrink: 0;
        }

        .ab-pill {
          display: inline-flex;
          align-items: center;
          gap: 6px;
          font-family: 'JetBrains Mono', monospace;
          font-size: 10.5px;
          letter-spacing: 0.05em;
          padding: 5px 11px;
          border-radius: 20px;
          margin-top: 14px;
        }

        .ab-cta {
          margin-top: 28px;
          display: flex;
          gap: 10px;
          flex-wrap: wrap;
        }

        .ab-btn {
          font-family: 'Inter', sans-serif;
          font-size: 13px;
          font-weight: 500;
          height: 36px;
          padding: 0 18px;
          border-radius: 5px;
          border: 0.5px solid rgba(0,0,0,0.12);
          background: #ffffff;
          color: #1a1a1a;
          cursor: pointer;
          transition: background 0.15s, border-color 0.15s;
        }
        .ab-btn:hover { background: #f3f2f1; }

        .ab-btn-primary {
          background: #c8571a;
          color: #fff;
          border-color: #c8571a;
        }
        .ab-btn-primary:hover { background: #a84514; border-color: #a84514; }
      `}</style>

      <div className="ab-root">

        <button className="ab-back" onClick={() => navigate("/")}>
          <svg width="14" height="14" viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round">
            <path d="M10 3L5 8l5 5" />
          </svg>
          Back to Home
        </button>

        <div className="ab-title">About <em>Lliuq</em></div>
        <div className="ab-sub">What it is, why it exists, and how it handles your data.</div>

        {/* Origin story */}
        <div className="ab-card">
          <div className="ab-card-head">
            <div className="ab-card-icon" style={{ background: "#fff3ed" }}>
              <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="#c8571a" strokeWidth="1.6" strokeLinecap="round">
                <path d="M12 2a5 5 0 1 0 0 10A5 5 0 0 0 12 2z" />
                <path d="M4 20c0-4 3.6-7 8-7s8 3 8 7" />
              </svg>
            </div>
            <div className="ab-card-title">Why Lliuq exists</div>
          </div>
          <p className="ab-body">
            It started with a simple need. Preparing for an interview, the first app hit a paywall after two tries.
            The second one too. Then the third. Every tool that could actually help had a gate in front of it.
            So the decision was made to build something and make it free, because nobody should have to stop
            mid-preparation just because they cannot pay. Lliuq is not built against anyone or anything.
            It is just built so that the tools are there, open, and ready whenever you need them.
            You do your work, you own it, and you walk away with it. That is the whole idea.
          </p>
        </div>

        {/* What is Lliuq */}
        <div className="ab-card">
          <div className="ab-card-head">
            <div className="ab-card-icon" style={{ background: "#f3f0f9" }}>
              <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="#6a4aaa" strokeWidth="1.6" strokeLinecap="round">
                <rect x="3" y="3" width="7" height="7" rx="1" />
                <rect x="14" y="3" width="7" height="7" rx="1" />
                <rect x="3" y="14" width="7" height="7" rx="1" />
                <rect x="14" y="14" width="7" height="7" rx="1" />
              </svg>
            </div>
            <div className="ab-card-title">What is Lliuq?</div>
          </div>
          <p className="ab-body">
            Lliuq is a set of AI tools that help you put your best work forward. Write and review a statement of purpose,
            practice for a scholarship interview, transcribe a meeting or lecture, polish your CV.
            Everything runs entirely in your browser using AI models you connect yourself.
            No account needed. Nothing stored on any server. Your work stays yours.
          </p>
          <div className="ab-tools-grid">
            <div className="ab-tool-chip">
              <div className="ab-tool-chip-name" style={{ color: "#c8571a" }}>Scribe</div>
              <div className="ab-tool-chip-tag">Transcription</div>
            </div>
            <div className="ab-tool-chip">
              <div className="ab-tool-chip-name" style={{ color: "#1a7a4a" }}>Interview</div>
              <div className="ab-tool-chip-tag">Scholarship prep</div>
            </div>
            <div className="ab-tool-chip">
              <div className="ab-tool-chip-name" style={{ color: "#6a4aaa" }}>Prose</div>
              <div className="ab-tool-chip-tag">SOP builder</div>
            </div>
            <div className="ab-tool-chip">
              <div className="ab-tool-chip-name" style={{ color: "#1a3a6b" }}>Mirror</div>
              <div className="ab-tool-chip-tag">CV studio · soon</div>
            </div>
          </div>
        </div>

        {/* Why free */}
        <div className="ab-card">
          <div className="ab-card-head">
            <div className="ab-card-icon" style={{ background: "#edfaf3" }}>
              <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="#1a7a4a" strokeWidth="1.6" strokeLinecap="round">
                <path d="M12 2v20M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6" />
              </svg>
            </div>
            <div className="ab-card-title">Completely free</div>
          </div>
          <p className="ab-body">
            Lliuq runs on your own Groq API key. You pay only for what you use, directly to Groq, at their rates.
            There is no markup, no subscription, and no platform fee. The tool itself is free and will stay free.
            Groq offers a generous free tier, so for most people the cost of using Lliuq is nothing at all.
          </p>
          <div className="ab-pill" style={{ background: "#edfaf3", color: "#1a7a4a", border: "0.5px solid #a0d0b0" }}>
            <svg width="11" height="11" viewBox="0 0 16 16" fill="none" stroke="#1a7a4a" strokeWidth="1.6">
              <path d="M3 8l4 4 6-7" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
            No subscription · No markup · No middleman
          </div>
        </div>

        {/* Models */}
        <div className="ab-card">
          <div className="ab-card-head">
            <div className="ab-card-icon" style={{ background: "#fff3ed" }}>
              <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="#c8571a" strokeWidth="1.6" strokeLinecap="round">
                <ellipse cx="12" cy="5" rx="9" ry="3" />
                <path d="M3 5v5c0 1.66 4 3 9 3s9-1.34 9-3V5" />
                <path d="M3 10v5c0 1.66 4 3 9 3s9-1.34 9-3v-5" />
              </svg>
            </div>
            <div className="ab-card-title">AI models</div>
          </div>
          <p className="ab-body">
            Lliuq runs on two Llama models served through Groq. Both are preassigned to specific tasks on the platform
            and selected automatically based on what each tool needs. You do not need to choose or configure anything.
            If you hit a usage quota on one model, you can switch to the other from within the tool
            without losing your session. Both models are available on Groq's free tier.
          </p>
          <div className="ab-model-row">
            <div className="ab-model-chip">
              <div className="ab-model-dot" />
              llama-3.3-70b-versatile
            </div>
            <div className="ab-model-chip">
              <div className="ab-model-dot" />
              llama-4-scout-17b-16e-instruct
            </div>
          </div>
        </div>

        {/* Privacy */}
        <div className="ab-card">
          <div className="ab-card-head">
            <div className="ab-card-icon" style={{ background: "#f0f3f9" }}>
              <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="#1a3a6b" strokeWidth="1.6" strokeLinecap="round">
                <path d="M12 2L4 5v6c0 5.25 3.5 10.15 8 11.35C16.5 21.15 20 16.25 20 11V5l-8-3z" />
              </svg>
            </div>
            <div className="ab-card-title">Privacy</div>
          </div>
          <p className="ab-body">
            Your Prose SOP content, Scribe interaction, interview sessions, and personal information go directly from your browser to Groq.
            Lliuq has no server. It does not store, log, or transmit your data anywhere of its own.
            Session history is saved locally on your device using browser storage and never leaves your machine.
            Your API key is stored locally and only ever sent to Groq over HTTPS.
            Clearing your browser data removes everything completely.
          </p>
        </div>

        {/* Security */}
        <div className="ab-card">
          <div className="ab-card-head">
            <div className="ab-card-icon" style={{ background: "#f3f2f1" }}>
              <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="#5a5a5a" strokeWidth="1.6" strokeLinecap="round">
                <rect x="5" y="11" width="14" height="10" rx="2" />
                <path d="M8 11V7a4 4 0 0 1 8 0v4" />
                <circle cx="12" cy="16" r="1" fill="#5a5a5a" />
              </svg>
            </div>
            <div className="ab-card-title">Security</div>
          </div>
          <p className="ab-body">
            Because Lliuq runs entirely in your browser with no backend, there is no database to breach,
            no account to compromise, and no server holding your data. Your API key lives in local browser storage
            and is transmitted only to Groq over HTTPS. You can revoke or rotate your key at any time
            from your Groq dashboard without touching anything here.
            If you are on a shared device, clear your browser storage after each session.
          </p>
        </div>

        <div className="ab-cta">
          <button className="ab-btn" onClick={() => navigate("/")}>Back to Home</button>
        </div>

        <div style={{
            marginTop: 40,
            paddingTop: 20,
            borderTop: "0.5px solid rgba(0,0,0,0.07)",
            textAlign: "center"
            }}>
            <p style={{ fontSize: 11, color: "#b0b0b0", lineHeight: 1.8, margin: 0 }}>
                Lliuq is free to use for personal, academic, and professional purposes.
                You may not sell, resell, or repackage it as a product or service.
                © 2026 Lliuq. All rights reserved.
            </p>
        </div>

      </div>
    </>
  );
}